import React from "react";
import { SHOW_ALL, CABS_LISTING_ROUTE, SEARCH_PAGE } from "../../../../../shared/utils/util-constants";
import { gcTripCategoryScreen, pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { CTA_TYPE, getActionNameForOmniture } from "../../../../../shared/utils/omni-utils";
import * as S from "./OtherCabOptions.styles";

interface ICabOptions {
  o_c_i: Array<{
    t?: string;
    icon?: {
      t?: string;
      bc?: string;
    };
  }>;
  showMore: boolean;
  toggleFn: Function;
  o_c_m: string;
  index: number;
  cdLen: number;
}

const OtherCabOptionsUI: React.FC<ICabOptions> = ({
  o_c_i,
  o_c_m,
  showMore = false,
  toggleFn = () => {},
  index = 0,
  cdLen = 0,
}) => {
  if (!o_c_m && !o_c_i?.length) return null;
  return (
    <S.OptionWrapper onClick={() => {
      if (!showMore) {
        pushCtaOmniEvents(getActionNameForOmniture(gcTripCategoryScreen, SHOW_ALL), CTA_TYPE.HYPER_LINK, SEARCH_PAGE, CABS_LISTING_ROUTE)
      }
      toggleFn(index)
    }}>
      {!showMore && (
        <S.OptionWrapperLeft>
          <S.InfoText>
            <span dangerouslySetInnerHTML={{ __html: o_c_m }}></span>
          </S.InfoText>
          <ul className="optionList">
            {o_c_i?.map(({ t, icon = {}}, index) => (
              <li key={`optionList${index}`}>
                {icon?.t ? <span className="liquid" style={{ background: icon?.bc }} >{icon?.t}</span> : null}
                <span>{t}</span>
              </li>
            ))}
          </ul>
        </S.OptionWrapperLeft>
      )}
      {(cdLen > 1) ? (
        <S.OptionWrapperRight>
          <span
            className={showMore ? "btnToggle toggleUp" : "btnToggle"}
          >
            {showMore ? "HIDE ALL" : "SHOW ALL"}
          </span>
        </S.OptionWrapperRight>
      ) : null}
    </S.OptionWrapper>
  );
};

export default React.memo(OtherCabOptionsUI);
